"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _system = require("@wix/wix-ui-icons-common/system");
var _TickerSt = require("./Ticker.st.css");
var _InputConsumer = _interopRequireDefault(require("../InputConsumer"));
var _constants = require("./constants");
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Input/Ticker/Ticker.js";
var Ticker = _ref => {
  var {
    onUp,
    onDown,
    upDisabled,
    downDisabled,
    onMouseDown,
    dataHook
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_InputConsumer.default, {
    consumerCompName: Ticker.displayName,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 3
    }
  }, _ref2 => {
    var {
      disabled,
      readOnly,
      size
    } = _ref2;
    var isUpDisabled = upDisabled || disabled || readOnly;
    var isDownDisabled = downDisabled || disabled || readOnly;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _TickerSt.st)(_TickerSt.classes.root, {
        size
      }),
      onMouseDown: onMouseDown,
      "data-hook": dataHook,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-hook": _constants.dataHooks.tickerUp,
      "data-disabled": isUpDisabled,
      className: (0, _TickerSt.st)(_TickerSt.classes.up, {
        disabled: isUpDisabled
      }),
      onClick: isUpDisabled ? null : onUp,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_system.FormFieldSpinnerUp, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 13
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      "data-hook": _constants.dataHooks.tickerDown,
      "data-disabled": isDownDisabled,
      className: (0, _TickerSt.st)(_TickerSt.classes.down, {
        disabled: isDownDisabled
      }),
      onClick: isDownDisabled ? null : onDown,
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_system.FormFieldSpinnerDown, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 13
      }
    })));
  });
};
Ticker.displayName = 'Input.Ticker';
Ticker.propTypes = {
  onUp: _propTypes.default.func,
  onDown: _propTypes.default.func,
  upDisabled: _propTypes.default.bool,
  downDisabled: _propTypes.default.bool,
  onMouseDown: _propTypes.default.func,
  dataHook: _propTypes.default.string
};
var _default = exports.default = Ticker;
//# sourceMappingURL=Ticker.js.map